import React from 'react'
import PropTypes from 'prop-types'
import {Col, H3, Row, ButtonPrimary} from '@modifi/ui'
import {useTranslation} from '@modifi/plugin-i18n'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Description} from './styles'

const propTypes = {
  params: PropTypes.shape({
    isPassThrough: PropTypes.bool.isRequired,
    sendPassThroughEmailToUser: PropTypes.string.isRequired,
  }).isRequired,
  handleClose: PropTypes.func.isRequired,
}

const defaultProps = {}

type EditTransactionDialogProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const UpdateTransactionSuccessDialog: React.FC<EditTransactionDialogProps> = ({
  params: {isPassThrough, sendPassThroughEmailToUser},
  handleClose,
}) => {
  const {t} = useTranslation('moneta')

  return (
    <>
      <Row justifyContent="center">
        <Col auto>
          <H3 mt={40}>{t('update-transaction-success.dialog.header')}</H3>
        </Col>
      </Row>

      <Row my={24}>
        <Col col={10} offset={1}>
          <Description>
            {t(
              `update-transaction-success.dialog.${isPassThrough ? 'unmark' : 'mark'}-transaction${
                sendPassThroughEmailToUser ? '.send-email' : ''
              }.sub-header`
            )}
          </Description>
        </Col>
      </Row>
      <>
        <Row justifyContent="center" mt={40}>
          <Col auto>
            <ButtonPrimary data-target="close-success" onClick={handleClose}>
              {t('update-transaction-success.close.cta')}
            </ButtonPrimary>
          </Col>
        </Row>
      </>
    </>
  )
}

UpdateTransactionSuccessDialog.propTypes = propTypes
UpdateTransactionSuccessDialog.defaultProps = defaultProps

export default UpdateTransactionSuccessDialog
